import request from '../utils/request';
//获取个人资料
export function getUserDetail(data) {
  return request({
    url: '/user/getUserDetail',
    method: 'post',
    data,
  })
}

//修改个人资料
export function doUpdatePerson(data) {
  return request({
    url: '/user/doUpdatePerson.do',
    method: 'post',
    data,
  })
}

//获取报名班级列表
export function toPersonalCenter(data) {
  return request({
    url: 'user/toPersonalCenter.do',
    method: 'post',
    data,
  })
}

//获取报名信息
export function getMaterials(data) {
  return request({
    url: 'user/getMaterials.do',
    method: 'post',
    data,
  })
}

//修改报名信息
export function doSaveMaterials(data) {
  return request({
    url: '/user/doSaveMaterials.do',
    method: 'post',
    data,
  })
}
